import { IStampDutyCountry } from "../forms/types";
import { IRuleMapping } from "./interfaces";

const engNIOnlyPropertyCharges = {
  125_000: 0,
  250_000: 0.02,
  925_000: 0.05,
  1_500_000: 0.1,
  [Infinity]: 0.12,
};

const scotOnlyPropertyCharges = {
  145_000: 0,
  250_000: 0.02,
  325_000: 0.05,
  750_000: 0.1,
  [Infinity]: 0.12,
};

const engNIOnlyProperty: IRuleMapping = [
  {
    country: IStampDutyCountry.ENG_NI,
    isOnlyProperty: true,
  },
  engNIOnlyPropertyCharges,
];

// value higher than 500k should go to engNIOnlyPropertyCharges
const engNIOnlyPropertyFirstTimeBuyerOver500k: IRuleMapping = [
  {
    country: IStampDutyCountry.ENG_NI,
    isOnlyProperty: true,
    propertyValueThreshold: 500_000,
    isFirstTimeBuyer: true,
    overFirstTimeBuyerThreshold: true,
  },
  engNIOnlyPropertyCharges,
];

const engNIOnlyPropertyFirstTimeBuyer: IRuleMapping = [
  {
    country: IStampDutyCountry.ENG_NI,
    isOnlyProperty: true,
    propertyValueThreshold: 500_000,
    overFirstTimeBuyerThreshold: false,
    isFirstTimeBuyer: true,
  },
  {
    300_000: 0,
    500_000: 0.05,
    [Infinity]: 0.12,
  },
];

const engNIAdditionalProperty: IRuleMapping = [
  {
    country: IStampDutyCountry.ENG_NI,
    isOnlyProperty: false,
  },
  {
    125_000: 0.05,
    250_000: 0.07,
    925_000: 0.10,
    1_500_000: 0.15,
    [Infinity]: 0.17,
  },
];

const scotland: IRuleMapping = [
  {
    country: IStampDutyCountry.SCOT,
    isOnlyProperty: true,
  },
  scotOnlyPropertyCharges
];

// value higher than 175k should go to engNIOnlyPropertyCharges
const scotlandOnlyPropertyFirstTimeBuyerOver175k: IRuleMapping = [
  {
    country: IStampDutyCountry.SCOT,
    isOnlyProperty: true,
    isFirstTimeBuyer: true,
    propertyValueThreshold: 175_000,
    overFirstTimeBuyerThreshold: true,
  },
  {
    175_000: 0,
    250_000: 0.02,
    325_000: 0.05,
    750_000: 0.1,
    [Infinity]: 0.12,
  },
];

const scotlandOnlyPropertyFirstTimeBuyerUnder175k: IRuleMapping = [
  {
    country: IStampDutyCountry.SCOT,
    isOnlyProperty: true,
    isFirstTimeBuyer: true,
  },
  {
    175_000: 0,
    [Infinity]: 0,
  },
];

const scotlandAdditionalProperty: IRuleMapping = [
  {
    country: IStampDutyCountry.SCOT,
    isOnlyProperty: false,
  },
  scotOnlyPropertyCharges
];

const walesOnlyPropertyCharges = {
  225_000: 0,
  400_000: 0.06,
  750_000: 0.075,
  1_500_000: 0.1,
  [Infinity]: 0.12,
};

const welsh: IRuleMapping = [
  {
    country: IStampDutyCountry.WALES,
    isOnlyProperty: true,
  },
  walesOnlyPropertyCharges
];

// No first time buyer relief in Wales :(
const welshInFirstTimeBuyer: IRuleMapping = [
  {
    country: IStampDutyCountry.WALES,
    isOnlyProperty: true,
    isFirstTimeBuyer: true,
  },
  walesOnlyPropertyCharges
];

const welshAdditionalProperty: IRuleMapping = [
  {
    country: IStampDutyCountry.WALES,
    isOnlyProperty: false,
  },
  {
    180_000: 0.05,
    250_000: 0.085,
    400_000: 0.1,
    750_000: 0.125,
    1_500_000: 0.15,
    [Infinity]: 0.17,
  },
];

export const mappings: Array<[any, any]> = [
  engNIOnlyProperty,
  engNIOnlyPropertyFirstTimeBuyer,
  engNIAdditionalProperty,
  engNIOnlyPropertyFirstTimeBuyerOver500k,
  scotland,
  scotlandOnlyPropertyFirstTimeBuyerOver175k,
  scotlandOnlyPropertyFirstTimeBuyerUnder175k,
  scotlandAdditionalProperty,
  welsh,
  welshInFirstTimeBuyer,
  welshAdditionalProperty,
];
